import { animate } from "motion";

const getPageOffset = () => {
  let offset = 0;

  const siteHeader = document.querySelector(".site-header");

  if (siteHeader) {
    const siteHeaderOffset = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--site-header-stuck-height");

    offset += parseInt(siteHeaderOffset);
  }

  return offset;
};

export const scrollTo = (target, additionalOffset = 0) => {
  if (!target) {
    return;
  }

  const pageOffset = getPageOffset();

  if (target.dataset.scrollOffset) {
    additionalOffset = parseInt(target.dataset.scrollOffset);
  }

  const offset = pageOffset + additionalOffset;
  const duration = 500;
  const startY = window.scrollY;
  const targetY = target.getBoundingClientRect().top + window.scrollY;
  const distance = targetY - startY - offset;

  animate(0, 1, {
    duration: duration / 1000,
    easing: "ease-in-out",
    onUpdate: (progress) => {
      window.scrollTo(0, startY + distance * progress);
    },
  });
};

export const scrollToIfNeeded = (target, additionalOffset = 0) => {
  const rect = target.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const isInViewport = rect.top >= 0 && rect.bottom <= viewportHeight;
  const is50PercentFromTop = rect.top <= viewportHeight / 2;

  if (!isInViewport || !is50PercentFromTop) {
    return scrollTo(target, additionalOffset);
  }
};
